const timelineData = [
  {
    text: "Started Learning React Js",
    date: "February 2020",
    category: {
      tag: "React Js",
      color: "red",
    },
    link: {
      url: "https://reactjs.org/",
      text: "React Js Website",
    },
  },
  {
    text: "Made COVID Dashboard app with React",
    date: "April 2020",
    category: {
      tag: "React Js",
      color: "#018f69",
    },
    link: {
      url: "https://blissful-kowalevski-e7ad98.netlify.app/",
      text: "Covid 19 Dashboard",
    },
  },
];
export default timelineData;
